<template>
    <v-dialog v-model="dialog" width="800px">
        <v-form ref="assignLeadForm">
            <v-card>
                <v-card-title class="justify-center">Agent preferences</v-card-title>
                <v-card-text class="justify-center">{{ agent_name }}</v-card-text>
                <v-divider></v-divider>
                <v-row no-gutters class="mx-5">
                    <v-col cols=6>New lead emails</v-col>
                    <v-col cols=6><v-select v-model="prefs.new_lead_emails" :items="new_lead_options" item-value="value" item-text="key" dense></v-select></v-col>
                </v-row>
                <v-row no-gutters class="mx-5">
                    <v-col cols=6>Action reminder emails</v-col>
                    <v-col cols=6><v-select v-model="prefs.action_reminder_emails" :items="action_reminder_options" item-value="value" item-text="key" dense></v-select></v-col>
                </v-row>
                <v-row no-gutters class="mx-5">
                    <v-col cols=6>Dashboard</v-col>
                    <v-col cols=6><v-select v-model="prefs.dashboard" :items="dashboard_options" item-value="value" item-text="key" dense></v-select></v-col>
                </v-row>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" small @click="savePrefs">Save</v-btn>
                    <v-btn color="primary" small @click="closePrefs">Cancel</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
    export default {
        components: {
        },
        props: {
        },
        data() {
            return {
                dialog: false,
                agent: "",
                agent_name: "",
                prefs: {
                    new_lead_emails: "direct",
                    action_reminder_emails: "daily",
                    dashboard: "normal"
                },
                new_lead_options: [{
                    key: "Immediately",
                    value: "direct"
                }, {
                    key: "Daily (weekdays)",
                    value: "daily"
                }, {
                    key: "Weekly (monday)",
                    value: "weekly"
                }, {
                    key: "Never",
                    value: "never"
                }],
                action_reminder_options: [{
                    key: "Daily (weekdays)",
                    value: "daily"
                }, {
                    key: "Weekly (monday)",
                    value: "weekly"
                }, {
                    key: "Never",
                    value: "never"
                }],
                dashboard_options: [{
                    key: "Normal agent dashboard",
                    value: "normal"
                }, {
                    key: "Social media leads dashboard",
                    value: "social"
                }],
            }
        },
        methods: {
            openDialog(agent) {
                this.agent = agent;
                this.dialog = false;
                this.getPtenAgentPrefs();
            },
            getPtenAgentPrefs() {
                this.$axios.post("ares/json/ares/pten/getPtenAgentPrefs.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getPtenAgentPrefs",
                    },
                    getPtenAgentPrefs: {
                        agent: this.agent
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.prefs = res.data.getPtenAgentPrefs;
                        this.agent_name = res.data.agent_name;
                        this.dialog = true;
                    }
                });

            },
            savePrefs() {
                this.$axios.post("ares/json/ares/pten/setPtenAgentPrefs.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "setPtenAgentPrefs",
                    },
                    setPtenAgentPrefs: {
                        agent: this.agent,
                        prefs: this.prefs,
                    },
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.setPtenAgentPrefs.text,
                            color: res.data.setPtenAgentPrefs.color,
                        });
                        this.$emit("actionClick", "refresh");
                        this.dialog = false;
                    }
                });
            },
            closePrefs() {
                this.dialog = false;
            },
        }
    }
</script>

